import {
  BubbleChatIcon,
  Calendar03Icon,
  CheckmarkCircle02Icon,
  Clock01Icon,
  InformationCircleIcon,
  Message01Icon,
  Notification03Icon,
  SentIcon,
  UserSwitchIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import { cx } from "shared/utils";
import { LinkifiedText } from "shared/utils/linkify-text";
import { LeadActivity } from "views/leads-id/types";
import {
  describeShowingRescheduleRequest,
  type RescheduleLineIcon
} from "views/leads-id/slices/Details/slices/ActivityLog/components/TimeLine/showing-reschedule-request";

const LINE_ICONS: Record<RescheduleLineIcon, typeof Calendar03Icon> = {
  calendar: Calendar03Icon,
  clock: Clock01Icon,
  note: BubbleChatIcon,
  sent: SentIcon,
  message: Message01Icon,
  check: CheckmarkCircle02Icon,
  assignee: UserSwitchIcon,
  info: InformationCircleIcon,
  bell: Notification03Icon
};

// One fact per line, each with its icon (CRM-1733 design).
export const ShowingRescheduleRequestDescription = ({
  activity
}: {
  activity: LeadActivity;
}) => {
  const lines = describeShowingRescheduleRequest(activity);
  if (lines.length === 0) return null;

  return (
    <div className="space-y-1">
      {lines.map((item) => (
        <div
          key={item.key}
          className={cx(
            "flex items-start gap-2 text-sm leading-5",
            item.tone === "danger" ? "text-danger-600" : "text-content-400"
          )}
        >
          <HugeiconsIcon
            icon={LINE_ICONS[item.icon]}
            size={14}
            className="mt-[3px] shrink-0"
            aria-hidden="true"
          />
          <p
            className={cx(
              "min-w-0 text-sm",
              item.linkify ? "whitespace-pre-wrap break-words" : ""
            )}
          >
            {item.linkify ? <LinkifiedText text={item.text} /> : item.text}
            <Show if={Boolean(item.struck)}>
              <span className={cx("line-through", item.text ? "ml-1.5" : "")}>
                {item.struck}
              </span>
            </Show>
          </p>
        </div>
      ))}
    </div>
  );
};
